import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Button } from './ui/button'
import { ChevronLeft } from 'lucide-react'

const BackButton = ({ title }) => {
  const navigate = useNavigate()
  return (
    <Button
      onClick={() => navigate(-1)}
      size='back'
      variant='back'
      className='text-black-500 font-semibold lg:text-xl'
    >
      <ChevronLeft className='text-black-500 h-5' />
      {title}
    </Button>
  )
}

export default BackButton
